/**
 * Location module UI labels
 * These are default labels that can be overridden per company
 */
export const LOCATION_LABELS = {
  location: "Location",
  locations: "Locations",
  locationName: "Location Name",
  locationAddress: "Location Address",
  addLocation: "Add Location",
  createLocation: "Create Location",
  editLocation: "Edit Location",
  locationDetails: "Location Details",
  locationsManagement: "Locations Management",
  selectLocation: "Select a saved Location",
  addNewLocation: "+ Add New Location",
  siteNumber: "Site Number/Location name",
  // Location Drawer labels
  country: "Country",
  contactName: "Contact Name",
  contactPhone: "Contact Phone",
  contactEmail: "Contact Email",
  // Location Modal Form labels
  primaryContact: "Primary Contact",
  fullName: "Full Name",
  address1: "Address 1",
  address2: "Address 2",
  searchNewAddress: "Search New Address",
  deleteLocationQuestion: "Delete '{name}' ?",
  nA: "N/A",
} as const;

export type LocationLabelKey = keyof typeof LOCATION_LABELS;

